import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const TEAM_FEATURE_GROUP: FeatureGroup = {
  guid: 'dea86780-cff4-4445-b969-4aae61acff00',
  name: 'team',
  description: 'Team management features — invite, view, edit, and remove users',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
